/* import __COLOCATED_TEMPLATE__ from './company-profile-info.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { htmlSafe } from '@ember/template';
import { dropTask } from 'ember-concurrency';
import { stripTags } from 'sh-www/utils/misc';

const CLASS_NAME = 'SH-c-company-profile-info';

class CompanyProfileInfoComponent extends Component {
  @service('state-managers/application')
  applicationStateManager;

  @tracked
  editing = false;

  @tracked
  value = '';

  get sanitizedDescription() {
    const sanitized = stripTags(this.args.company.description, ['br', 'p', 'b'])
      .replace(/\n/g, '<br>');

    return sanitized
      ? htmlSafe(sanitized)
      : 'No background info provided.';
  }

  get saving() {
    return this.updateCompanyDescription.isRunning;
  }

  get confirmDisabled() {
    return this.saving || !this.value.trim() || this.value === this.args.company.description;
  }

  get className() {
    return CLASS_NAME;
  }

  @action
  onCancel() {
    this.editing = false;
    this.value = '';
  }

  @action
  onClick() {
    this.editing = true;
    this.value = this.args.company.description ?? '';
  }

  @action
  onInput(value) {
    this.value = value;
  }

  @action
  onKeyDown(e) {
    if (e.key === 'Escape') {
      this.onCancel();
    }
  }

  @dropTask
  *updateCompanyDescription() {
    try {
      yield this.args.saveCompanySettings({
        slug: this.args.company.slug,
        description: this.value,
      });
    } catch {
      this.applicationStateManager.addToast('Failed to save company description');
    }

    this.onCancel();
  }
}

export default CompanyProfileInfoComponent;
